module.exports = __webpack_public_path__ + "7521904e49c767824f3cb3da7ecce91c.svg";